const AboutVisionMission = () => {
    return (
        <section className="w-full bg-white text-[#082f49] py-20 px-6 md:px-20">
            <div className="max-w-7xl mx-auto">
                <h2 className="text-3xl font-bold mb-6">
                    Tầm nhìn
                </h2>

                <p className="text-lg mb-10 leading-relaxed">
                    Trở thành chuyên gia bất động sản hàng đầu Việt Nam,
                    mang đến trải nghiệm đáng tin cậy, minh bạch và hiện đại.
                </p>

                <h2 className="text-3xl font-bold mb-6">
                    Sứ mệnh
                </h2>

                <p className="text-lg leading-relaxed">
                    Cung cấp giải pháp bất động sản toàn diện từ mua bán,
                    cho thuê, tư vấn đầu tư đến quản lý dự án.
                </p>
            </div>
        </section>
    );
};

export default AboutVisionMission;